import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'

export default function MobileMenu({ isOpen, onClose, navItems }) {
  if (!isOpen) return null
  
  return (
    <div 
      className="fixed inset-0 z-50 flex flex-col"
      style={{
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        backdropFilter: 'blur(100px)'
      }}
    >
      {/* Header */}
      <header className="flex h-[68px] px-4 justify-between items-center">
        <Link to="/" onClick={onClose}>
          <img 
            src="/images/logo-white.svg" 
            alt="Coupang Play Logo" 
            style={{
              width: '159.78px',
              height: '19.999px'
            }}
          />
        </Link>
        
        <button
          onClick={onClose}
          className="w-12 h-12 flex items-center justify-center"
          aria-label="Close menu"
        >
          <div className="w-6 h-6 relative">
            <span className="absolute top-1/2 left-0 w-6 h-0.5 bg-white transform rotate-45"></span>
            <span className="absolute top-1/2 left-0 w-6 h-0.5 bg-white transform -rotate-45"></span>
          </div>
        </button>
      </header>
      
      {/* Menu Content */}
      <div className="flex-1 flex items-center justify-center px-6 py-20">
        <nav className="flex flex-col items-center gap-8">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              onClick={onClose}
              style={{
                color: '#FFF',
                textAlign: 'center',
                fontFamily: 'Pretendard',
                fontSize: '32px',
                fontStyle: 'normal',
                fontWeight: 700,
                lineHeight: '145%',
                letterSpacing: '-0.16px',
                textTransform: 'uppercase'
              }}
              className="hover:opacity-80 transition-opacity"
            >
              {item.label}
            </Link>
          ))}
        </nav>
      </div>
    </div>
  )
}

MobileMenu.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  navItems: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  ).isRequired
}
